export enum WageFrequency {
    YEAR = 'YEAR',
    MONTH = 'MONTH',
    WEEK = 'WEEK',
    BIWEEKLY = 'BIWEEKLY',
    SEMIMONTHLY = 'SEMIMONTHLY',
    HOUR = 'HOUR'
}